import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import './App.scss';
import Header from "./assets/Components/Header";
import Home from './assets/Pages/Home';
import About from './assets/Pages/About';
import Token from './assets/Pages/Token';
import Team from './assets/Pages/Team';
import Footer from './assets/Components/Footer';
import Spinner from "./assets/Components/Spinner";
import GenericPage from "./assets/Pages/GenericPage";
import useFetch from "./assets/hooks/useFetch";

export const ROUTE_HOME = '/';
export const ROUTE_ABOUT = '/about';
export const ROUTE_TOKEN_PAGE = '/token';
export const ROUTE_TEAM_PAGE = '/team';

export const BASE_URL = 'https://paribus-backend.herokuapp.com'
export const API_URL =  BASE_URL + '/api';

function App() {
  const { error, loading, data } = useFetch(API_URL + '/pages');

  if (loading) {
    return (
    <div className="page">
      <Spinner fullScreen />
    </div> );
  }
  
  return (
    <div className="page">
      <BrowserRouter>
       <Header pages={data?.data} />
        <Routes>
          <Route path={ROUTE_HOME} element={<Home />} />
          <Route path={ROUTE_ABOUT} element={<About />} />
          <Route path={ROUTE_TOKEN_PAGE} element={<Token />} />
          <Route path={ROUTE_TEAM_PAGE} element={<Team />} />
           {data && data.data && data?.data.map(pages => {
              return (
                <Route path={pages.attributes.route} element={ <GenericPage content={pages.attributes.content} />} />
              )
            })}
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
